module.exports = __webpack_public_path__ + "static/leek-6400a183577f558d006adb8a37c09066.svg";